import { type JSX, useContext } from "react";

import TableCell from "@mui/material/TableCell";
import Typography from "@mui/material/Typography";

import { FilterTable } from "../../../../Components/FilterTable/FilterTable";
import { CellsWrapper } from "../../../../Components/FilterTable/Toolbar/CellsWrapper";
import { type AwsAccount } from "../../data/aws-account-api";
import { AwsAccountContext } from "../../data/AwsAccountContext";
import { awsGeneratedAccountsColumns, awsGeneratedAccountsHeaders } from "./AwsAccountListColumns";
import { ActionsCell } from "./cells/ActionsCell";
import { StatusCell } from "./cells/StatusCell";

const AccountRow: (props: { row: AwsAccount }) => JSX.Element = ({ row }) => (
  <CellsWrapper>
    <TableCell
      sx={{
        display: {
          xs: "none",
          sm: "table-cell",
        },
      }}
    >
      <Typography>{row.accountName}</Typography>
    </TableCell>
    <TableCell
      sx={{
        display: {
          xs: "none",
          sm: "table-cell",
        },
      }}
    >
      <Typography>{row.email}</Typography>
    </TableCell>
    <TableCell
      sx={{
        display: {
          xs: "none",
          sm: "table-cell",
        },
      }}
    >
      <Typography>{row.genuineAwsAccountId}</Typography>
    </TableCell>
    <TableCell
      sx={{
        display: {
          xs: "none",
          sm: "table-cell",
        },
      }}
    >
      <StatusCell row={row} />
    </TableCell>
    <TableCell padding="checkbox">
      <ActionsCell row={row} />
    </TableCell>
  </CellsWrapper>
);

export const AwsAccountList = () => {
  const { awsAccounts } = useContext(AwsAccountContext);

  return (
    <FilterTable<AwsAccount>
      rowComponent={AccountRow}
      headerColumns={awsGeneratedAccountsHeaders}
      filterColumns={awsGeneratedAccountsColumns}
      tableItems={awsAccounts}
      defaultSortDirection="asc"
      defaultSortingColumnValue="accountName"
      data-cy="awsAccountsList"
    />
  );
};
